import { render, staticRenderFns } from "./SellerCounterpartySidebar.vue?vue&type=template&id=afad0e6c&scoped=true&"
import script from "./SellerCounterpartySidebar.vue?vue&type=script&lang=js&"
export * from "./SellerCounterpartySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afad0e6c",
  null
  
)

export default component.exports